/** @jsxImportSource @emotion/react */
import { EmptyData } from '@app/components/ui/EmptyData/EmptyData'
import { HazardActiveScenarioBar } from '@app/domains/hazards/components/HazardActiveScenarioBar'
import { HazardScenarioFilters } from '@app/domains/hazards/components/HazardScenarioFilters'
import { HazardScenarioGrid } from '@app/domains/hazards/components/HazardScenarioGrid'
import { HazardScenarioLegend } from '@app/domains/hazards/components/HazardScenarioLegend'
import { Box, Typography } from '@mui/material'
import { useOutletContext, useParams } from 'react-router-dom'
import { DataLayerDetailOutletContext } from '../types'
import { useDataLayerScenario } from '../hooks/useDataLayerScenario'

const DataLayerDetailScenarios = () => {
  const { layerId } = useParams<{ layerId: string }>()
  const { onSelectScenario, selectedAssetTag } = useOutletContext<DataLayerDetailOutletContext>()

  const {
    selectedScenario,
    filterableParams,
    grid,
    handleSelectScenario,
    handleResetFilters,
    hazardScopedScenarios,
  } = useDataLayerScenario({
    layerId: layerId || '',
    selectedAssetTag,
    onSelectScenario,
  })

  if (!layerId) {
    return <EmptyData title="Scenarios not available for this layer" />
  }

  return (
    <Box data-testid="data-layer-detail-scenarios-root" sx={{ paddingTop: 2, paddingBottom: 40 }}>
      {selectedScenario && <HazardActiveScenarioBar scenario={selectedScenario} />}

      <Typography
        data-testid="data-layer-detail-scenarios-title"
        fontSize={16}
        fontWeight={'bold'}
        gutterBottom
      >
        Available scenarios
      </Typography>

      <Typography
        data-testid="data-layer-detail-scenarios-description"
        variant="body2"
        color="text.secondary"
        sx={{ mb: 2 }}
      >
        Use the filter to narrow down scenarios, then click a pill to select one and view it on the
        map.
      </Typography>

      <HazardScenarioFilters
        layerId={layerId}
        scenarios={hazardScopedScenarios}
        filterableParams={filterableParams}
      />
      <HazardScenarioLegend scenarios={hazardScopedScenarios} dotLegend={grid.dotLegend} />
      <Box data-testid="data-layer-detail-scenarios-grid">
        <HazardScenarioGrid
          grid={grid}
          selectedAssetTag={selectedAssetTag}
          onSelect={handleSelectScenario}
          emptyState={
            <EmptyData
              title="No scenarios match the selected filters"
              showButton
              actionLabel="Reset filters"
              onAction={handleResetFilters}
              buttonIcon={null}
              borderColor="primary"
            />
          }
        />
      </Box>
    </Box>
  )
}

export default DataLayerDetailScenarios
